import { LightningElement } from "lwc";

export default class extends LightningElement {
  renderedCallback() {
    const table = this.template.host
      .querySelector("table")!
      .cloneNode(true) as HTMLElement;

    const select = (selector: string) => table.querySelector(selector);
    const selectAll = (selector: string) =>
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      Array.from(table.querySelectorAll(selector)) as HTMLElement[];

    const thead = select("thead")!;
    const tbody = select("tbody")!;
    const trows = selectAll("tr");
    const theaders = selectAll("th");

    const tableHeadeNarrow = document.createElement("span");
    tableHeadeNarrow.setAttribute("aria-hidden", "true");
    tableHeadeNarrow.classList.add("narrow-th");

    const headerValues = theaders.map((v) => v.innerText);

    table.setAttribute("role", "table");
    thead.setAttribute("role", "presentation");
    tbody.setAttribute("role", "presentation");

    theaders.forEach((elem) => {
      elem.setAttribute("role", "columnheader");
      elem.setAttribute("scope", "col");
    });

    trows.forEach((row) => {
      row.setAttribute("role", "row");

      Array.from(row.children).forEach((v, i) => {
        let cell = v as HTMLElement;
        cell.setAttribute("role", "gridcell");

        if (cell.querySelector("tds-button-link")) {
          cell.classList.add("button-cell");
        }

        if (headerValues[i]) {
          let header = tableHeadeNarrow.cloneNode();
          header.textContent = headerValues[i];
          cell.insertBefore(header, cell.firstChild);
        }
      });
    });

    const tableWrapper = this.template.querySelector(".table-wrapper")!;
    tableWrapper.firstChild?.remove();
    tableWrapper.append(table);
  }
}
